import { FC, useRef, useState } from 'react';
import cx from 'clsx';

import styles from './styles.module.css';
import BeatLoader from 'react-spinners/BeatLoader';
import { useLongPress } from 'src/hooks';
import { Icon } from 'src/components/Icon';

type Props = {
  onClick: () => void;
  src: string;
};

export const MediaGridVideo: FC<Props> = ({ onClick, src }) => {
  const [isMediaLoaded, setIsMediaLoaded] = useState(false);

  const ref = useRef<HTMLVideoElement>(null);

  const handleMediaLoaded = () => setIsMediaLoaded(true);

  const playVideo = () => {
    const videoElement = ref?.current;
    if (videoElement) {
      videoElement.play();
    }
  };

  const stopVideo = () => {
    const videoElement = ref?.current;
    if (videoElement) {
      videoElement.pause();
      videoElement.currentTime = 0.1;
    }
  };

  const { isPressed, touchHandlers } = useLongPress(playVideo, stopVideo);

  return (
    <>
      {!isMediaLoaded && (
        <div className={styles.mediaLoader}>
          <BeatLoader color="white" loading={true} />
        </div>
      )}

      {isMediaLoaded && <Icon className={styles.playIcon} name="play" />}

      <video
        className={cx(styles.media, {
          [styles.mediaFullScreen]: isPressed,
        })}
        playsInline
        preload="metadata"
        muted
        src={`${src}#t=0.1`}
        loop
        ref={ref}
        onLoadedData={handleMediaLoaded}
        onClick={onClick}
        {...touchHandlers}
      />
    </>
  );
};
